import { FilterFn } from '@tanstack/react-table';
import { InvoiceEvidenceView } from '../../../../../../types/entity-types';

export type MatchFilter = 'MATCHED' | 'UNMATCHED' | 'ALL';

export const matchTransactionStatusFilter: FilterFn<InvoiceEvidenceView> = (
  row,
  _columnId,
  filterValue?: MatchFilter,
) => {
  if (!filterValue || filterValue === 'ALL') {
    return true;
  }

  const hasMatch = !!row.original.transactionId;

  return filterValue === 'MATCHED' ? hasMatch : !hasMatch;
};

matchTransactionStatusFilter.autoRemove = (val: unknown) => !val;
